var _circle, _circle2, _path, _circle3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaternity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 16.867,
    cy: 27.062,
    r: 1.65
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 22.863,
    cy: 13.782,
    r: 6.848
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M26.966 20.638c-.05-.01-.11-.01-.16-.01h-7.89c-3.99 0-7.22 3.23-7.22 7.22v10.62h6.81"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 29.999,
    cy: 25.445,
    r: 4.868
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M33.697 28.608l.13.065-4.388 8.697c-.564 1.118-2.084 1.489-3.396.828L22.1 36.21c-1.312-.661-1.918-2.105-1.353-3.223l4.387-8.696.13.065"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M18.825 8.254s0-3.55-2.787-4.15c-2.384-.513-3.89.841-4.18 2.354-.161.84.525 2.998-4.206 4.662 0 0 3.752 1.664 6.363.946 2.61-.718 2.512-1.012 2.512-1.012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaternity);
export default __webpack_public_path__ + "static/media/maternity.c792d8d035a318e27957c293b139f9a5.svg";
export { ForwardRef as ReactComponent };